export const CARDS_EN = {
  BUTTON_TEXT_DOWNLOAD: 'Download',
};
